import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfileUserRoutingModule } from './profile-user-routing.module';
import { VerticalMenuTypeOneModule } from '../navigation';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { LoaderGlobeAnimationDetailComponent } from '../loaders';
import { ReactiveFormsModule } from '@angular/forms';
import { ProfileUserHomeComponent } from './profile-user-home/profile-user-home.component';
import { ProfilePictureSettingsComponent } from './profile-picture-settings/profile-picture-settings.component';
import { ProfileUserLanguagesComponent } from './languages/profile-user-languages.component';
import { ComingSoonModule, UserAvatarPipe } from '@frontend/shared';
import { ProfileUserNameComponent } from './profile-user-name/profile-user-name.component';
import { LanguageModule, UserLanguageEditorComponent } from '../language';
import { ProfileUserSocialLinksComponent } from './profile-user-social-links/profile-user-social-links.component';


@NgModule({
  declarations: [
    ProfileUserHomeComponent,
    ProfilePictureSettingsComponent,
    ProfileUserLanguagesComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ProfileUserNameComponent,
    ProfileUserSocialLinksComponent,
    ProfileUserRoutingModule,
    TranslocoModule,
    VerticalMenuTypeOneModule,
    AlertModule,
    LoaderGlobeAnimationDetailComponent,
    ComingSoonModule,
    LanguageModule,
    UserAvatarPipe,
    UserLanguageEditorComponent,


  ],
  exports: [
  
    ProfileUserHomeComponent
  ],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'profile' }],

})
export class ProfileUserModule { }
